/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PartnerAuthMode = {
    FULL_OAUTH: 'FULL_OAUTH',
    VIEW_ONLY: 'VIEW_ONLY',
    NONE: 'NONE'
} as const;
export type PartnerAuthMode = typeof PartnerAuthMode[keyof typeof PartnerAuthMode];


export function instanceOfPartnerAuthMode(value: any): boolean {
    for (const key in PartnerAuthMode) {
        if (Object.prototype.hasOwnProperty.call(PartnerAuthMode, key)) {
            if (PartnerAuthMode[key as keyof typeof PartnerAuthMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PartnerAuthModeFromJSON(json: any): PartnerAuthMode {
    return PartnerAuthModeFromJSONTyped(json, false);
}

export function PartnerAuthModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerAuthMode {
    return json as PartnerAuthMode;
}

export function PartnerAuthModeToJSON(value?: PartnerAuthMode | null): any {
    return value as any;
}

export function PartnerAuthModeToJSONTyped(value: any, ignoreDiscriminator: boolean): PartnerAuthMode {
    return value as PartnerAuthMode;
}

